module.exports = __webpack_public_path__ + "img/302_2.38ca8e94.jpg";